/**
 * @module lib/calculate-monthly-budget
 */
import { TAX_RATE } from '../data/constants';
/**
 * Calculates monthly budget for taxes, housing, debts, and everything else
 * @param {object} inputs
 * @param {number} inputs.annualIncome  Annual income
 * @param {number} inputs.monthlyDebt  Monthly debt obligations
 * @param {number} dti Requested debt to income
 * @returns {MonthlyBudget}
 */

export default function calculateMonthlyBudget(_ref, dti) {
  var annualIncome = _ref.annualIncome,
      monthlyDebt = _ref.monthlyDebt;
  var monthlyIncome = annualIncome / 12;
  var debtToIncome = monthlyDebt / monthlyIncome;
  var restToIncome = 1 - TAX_RATE - dti;
  var housingToIncome = dti - debtToIncome;
  return {
    // ratios
    debtToIncome: debtToIncome,
    housingToIncome: housingToIncome,
    taxesToIncome: TAX_RATE,
    restToIncome: restToIncome,
    // values
    monthlyIncome: monthlyIncome,
    taxes: TAX_RATE * monthlyIncome,
    rest: restToIncome * monthlyIncome
  };
}